import gql from 'graphql-tag';

export const updateOT = gql`
    mutation updateOT($_id: String, $input: OTObjectInput) {
        updateOT(_id: $_id, input: $input) {
            _id
            orden
            colada
            clave
            modelo {
                modelo
                acero
                limite_dureza_inferior 
                limite_dureza_superior
                unidad
                tipo_recocido
                ciclo
                temperatura1
                temperatura2
                enfriamiento1
                enfriamiento2
                temperatura_bano
                escurrido
                piezas_ban_h6
                piezas_ban_h5
                peso_pieza_df
                tempeartura_agua_df
            }
            disp
            estado
            fin
            inicio
            kgs
            name
            piezas
            duracion
            bandejas {
                usuario
                usuarioUUID
                tipo
                fecha
                cantidad
                __typename
            }
            comentarios {
                tipo
                usuario
                usuarioUUID
                fecha
                valor
            }
            muestras {
                unidad
                usuario
                usuarioUUID
                fecha
                valor
            }
            bono
        }
}`

export const deleteOT = gql`
    mutation deleteOT($_id: String, $td: String) {
        deleteOT(_id: $_id, td: $td) 
}`



